// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__vaZ78","right":"styles_right__3Cg7X"};